import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { aggregate } from '@debbie/common/dist/util/index.js';
import THEME from '../../theme.js';
import Modal from '../Modal.js';
import DefaultSummary from './DefaultSummary.js';
const EInvoiceSummary = (props) => {
    const lang = useSelector((s) => s.lang);
    const [eInvoiceEvent, setEInvoiceEvent] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const { interaction } = props;
    const events = interaction.events
        ? Object.values(aggregate(interaction.events.filter((event) => !['transmissionStarted', 'transmissionCompleted'].includes(event.type)), (event) => event.type))
        : [];
    return (React.createElement(DefaultSummary, { ...props },
        React.createElement("div", { style: { position: 'relative' } },
            React.createElement(EInvoiceStyled, null,
                interaction.events && interaction.events.length ? (React.createElement("div", { className: "to" },
                    React.createElement("span", null, lang.interactions.events),
                    ' ',
                    React.createElement(EventTags, null, events.map((events) => {
                        const event = events[0];
                        return (React.createElement("div", { key: event.id, "data-tooltip-content": events
                                .map((s) => `${moment(s.createdAt).format(THEME.DATE_FORMAT_LONG)}${s.data.statusDetails && s.data.statusDetails.state
                                ? `: ${s.data.statusDetails.state}`
                                : ''}`)
                                .join('<br/>'), "data-tooltip-id": "tooltip-default", className: event.type, onClick: () => {
                                setEInvoiceEvent(events.map((s) => {
                                    return {
                                        date: moment(s.createdAt).format(THEME.DATE_FORMAT_LONG),
                                        data: s.data.statusDetails &&
                                            `${JSON.stringify(s.data.statusDetails, null, 2)}`,
                                    };
                                }));
                                setOpenModal(!openModal);
                            } },
                            lang.interactions.eInvoiceEvents[event.type] || event.type,
                            ' ',
                            events.length > 1 ? `(${events.length})` : ''));
                    })))) : (''),
                openModal && (React.createElement(Modal, { onToggle: () => {
                        setEInvoiceEvent(null);
                        setOpenModal(!openModal);
                    }, header: lang.interactions.events }, eInvoiceEvent &&
                    Object.entries(eInvoiceEvent).map(([key, value]) => (React.createElement("div", { key: key },
                        React.createElement("h3", null, 
                        // @ts-ignore
                        value?.date),
                        React.createElement("pre", null, 
                        // @ts-ignore
                        value?.data))))))))));
};
export default EInvoiceSummary;
const EInvoiceStyled = styled.div `
  background: #fff;

  .from,
  .to,
  .body {
    border-bottom: 1px solid lightgrey;
    padding: 10px 15px;
  }

  .from > span:first-child,
  .to > span:first-child {
    width: 55px;
    opacity: 0.6;
    display: inline-block;
    text-align: right;
    margin-right: 10px;
    font-size: 0.75em;
  }

  .from > span:first-child:after,
  .to > span:first-child:after {
    content: ': ';
  }

  .body pre {
    overflow-wrap: break-word;
    word-break: break-word;
    white-space: pre-wrap;
  }

  .date {
    float: right;
    color: lightgrey;
  }

  border: 1px solid lightgrey;
  border-bottom: none;
`;
const EventTags = styled.span `
  & > div {
    background: ${THEME.SUCCESS};
    display: inline-block;
    border-radius: 3px;
    color: ${THEME.COLOR_SECONDARY};
    padding: 0.2em 0.6em;
    font-size: 0.7em;
    font-weight: bold;
    margin-right: 5px;

    &.failed,
    &.endpointNotFound,
    &.error {
      background: ${THEME.DANGEROUS};
    }
  }
`;
//# sourceMappingURL=EInvoiceSummary.js.map